// client/src/pages/Admin/ResourceManager/components/ResourceStatusBadge.tsx
import React from 'react';
import { ResourceStatus, Resource } from '../../../../shared/models/Resource';
import { renderStatusIcon, getStatusColor, formatStatusLabel } from '../utils/resourceHelpers';

interface ResourceStatusBadgeProps {
  status: ResourceStatus;
}

export const ResourceStatusBadge: React.FC<ResourceStatusBadgeProps> = ({ status }) => {
  const statusLabel = formatStatusLabel(status);
  const statusColor = getStatusColor(status);

  return (
    <span className={`status-chip ${statusColor}`}>
      {renderStatusIcon(status, 14)}
      <span className="status-label">{statusLabel}</span>
    </span>
  );
};